import { useFetcher } from '@/api/useFetcher.ts';
import { useQuery } from '@tanstack/react-query';
import { GetCompanyInfoResponse, Routes } from '@/api/types.ts';

export const useCompanyInfoQuery = () => {
  const fetchData = useFetcher();

  return useQuery<GetCompanyInfoResponse>({
    queryKey: [Routes.CompanyInfo],
    queryFn: () => fetchData(Routes.CompanyInfo),
  });
};
